"use strict";

import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--) if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import React from "react";
import { observer } from "mobx-react";
import classNames from "classnames";
export var SliderTheme = /* @__PURE__ */function (SliderTheme2) {
  SliderTheme2["Light"] = "light";
  SliderTheme2["Dark"] = "dark";
  return SliderTheme2;
}(SliderTheme || {});
var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);
  var _super = _createSuper(Slider);
  function Slider(props) {
    var _this;
    _classCallCheck(this, Slider);
    _this = _super.call(this, props);
    _this.onInputChange = function (event) {
      var inputValue = Number(event.target.value);
      if (isNaN(inputValue) || _this.isBelowMin(inputValue) || _this.isAboveMax(inputValue)) {
        return;
      } else {
        _this.props.onChange(inputValue);
      }
    };
    _this.isBelowMin = function (value) {
      return _this.props.minimum != void 0 && value < _this.props.minimum;
    };
    _this.isAboveMax = function (value) {
      return _this.props.maximum != void 0 && _this.props.maximum < value;
    };
    return _this;
  }
  _createClass(Slider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        minimum = _this$props.minimum,
        maximum = _this$props.maximum,
        theme = _this$props.theme,
        stepSize = _this$props.stepSize,
        label = _this$props.label,
        onMouseDown = _this$props.onMouseDown;
      return /* @__PURE__ */React.createElement("div", {
        className: "center-aligned",
        style: {
          width: "100%"
        }
      }, /* @__PURE__ */React.createElement("input", {
        className: classNames({
          "slider-input__range-input": true,
          "slider-input__range-input--dark": theme === "dark" /* Dark */
        }),

        type: "range",
        min: minimum,
        max: maximum,
        onChange: this.onInputChange,
        value: value,
        step: stepSize,
        "aria-label": label,
        "aria-valuenow": value,
        "aria-valuemin": minimum,
        "aria-valuemax": maximum,
        "aria-orientation": "horizontal",
        onMouseDown: onMouseDown
      }));
    }
  }]);
  return Slider;
}(React.Component);
Slider.defaultProps = {
  minimum: 0,
  maximum: 100,
  theme: "light" /* Light */,
  stepSize: 1
};
Slider = __decorateClass([observer], Slider);
export { Slider as default };